import * as React from 'react';
import { useTranslation } from "react-i18next";
import { Input, TextArea } from '@progress/kendo-react-inputs';
//import { FloatingLabel } from '@progress/kendo-react-labels';
import { Button } from '@progress/kendo-react-buttons';
import { DatePicker } from '@progress/kendo-react-dateinputs';
export default function OrdersDetailsComponents() {
    const { t } = useTranslation();

    const [value, setValue] = React.useState(new Date());
    const changeDate = ({ value }) => {
        setValue(value);
    };


    return (
        <div>

            <div className="container-fluid">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3 d-flex align-items-center justify-content-between">
                            <h5 className="card-title m-0">{t("Global_Label_Text_General")}</h5>
                            <div className="d-flex gap-2">
                                <Button className="action-button">{t("Global_Label_Text_Confirm")}</Button>
                                <Button className="action-button">{t("Global_Label_Text_In_progress")}</Button>
                                <Button className="action-button">{t("Global_Label_Text_Cancel")}</Button>
                            </div>
                        </div>


                        <div className="card-body">
                            <div className="row g-4 justify-content-center">
                                {/* Columna 1 */}
                                <div className="col-12 col-md-4">
                                    <div className="d-flex flex-column gap-3">
                                        <Input
                                            label={t("Global_Label_Text_Id")}
                                            className="w-100"
                                            style={{ width: "100%" }}
                                        />
                                        <Input
                                            label={t("Global_Label_Text_Integrator")}
                                            className="w-100"
                                            style={{ width: "100%" }}
                                        />
                                        <Input
                                            label={t("Global_Label_Text_Farm")}
                                            className="w-100"
                                            style={{ width: "100%" }}
                                        />
                                    </div>
                                </div>
                                {/* Columna 2 */}
                                <div className="col-12 col-md-4">
                                    <div className="d-flex flex-column gap-3">
                                        <Input
                                            label={t("Global_Label_Text_Been")}
                                            className="w-100"
                                            style={{ width: "100%" }}
                                        />
                                        <DatePicker
                                            label={t("Global_Label_Text_Creation_Date")}
                                            value={value}
                                            onChange={changeDate}
                                            style={{ width: "100%" }}
                                        />
                                        <DatePicker
                                            label={t("Global_Label_Text_Expected_Date")}

                                            value={value}
                                            onChange={changeDate}
                                            style={{ width: "100%" }}
                                        />
                                    </div>
                                </div>
                                {/* Columna 3 */}
                                <div className="col-12 col-md-4">
                                    <div className="d-flex flex-column gap-3">
                                        <DatePicker
                                            label={t("Global_Label_Text_Confirmation_Date")}
                                            value={value}
                                            onChange={changeDate}
                                            style={{ width: "100%" }}
                                        />
                                        <DatePicker
                                            label={t("Global_Label_Text_Delivery_Date")}
                                            value={value}
                                            onChange={changeDate}
                                            style={{ width: "100%" }}
                                        />
                                        <DatePicker
                                            label={t("Global_Label_Text_Date_Process")}
                                            value={value}
                                            onChange={changeDate}
                                            style={{ width: "100%" }}
                                            labelClassName="text-start"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_Remarks")}</h5>
                        </div>

                        <div className="container p-3 p-md-4">
                            <div className="row g-3 mb-3 mb-md-4">
                                <TextArea
                                    label={t("Global_Label_Text_Remarks")}
                                    rows={4}
                                    style={{ width: "100%" }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="d-flex justify-content-end mb-3">
                        <Button className="action-button me-lg-11">{t("Global_Label_Text_Save")}</Button>
                    </div>
                </div>
            </div>



        </div>


    );
}